import { z } from 'zod';

export const searchSchema = z.object({
  ngay_ct2: z.string().optional(),
  mau_bc: z.string().optional(),
  data_analysis_struct: z.string().optional(),
  report_filtering: z.string().optional()
});

export const initialValues = {
  ngay_ct2: new Date().toISOString().split('T')[0],
  mau_bc: 'TC',
  data_analysis_struct: '0',
  report_filtering: '1'
};

export type SearchFormValues = z.infer<typeof searchSchema>;
